import React from 'react';
import { Check } from 'lucide-react';

const ThankYou = () => {
  return (
    <div className="min-h-screen bg-dark-bg flex items-center justify-center p-4">
      <div className="bg-dark-secondary rounded-xl shadow-lg p-8 max-w-md w-full text-center animate-float">
        <div className="flex justify-center mb-6">
          <div className="bg-accent rounded-full p-4 animate-glow">
            <Check 
              className="text-white" 
              size={64} 
              strokeWidth={3}
            />
          </div>
        </div>
        
        <h1 className="text-3xl font-bold text-text-primary mb-4 animate-ping">
          Order Confirmed!
        </h1>
        
        <p className="text-text-secondary text-lg mb-6">
          Your order has been successfully processed. 
          Please check your inbox or spam folder to access your proxy orders.
        </p>
        
        <div className="bg-accent hover:bg-accent-hover transition-colors duration-300 text-white py-3 px-6 rounded-lg inline-block">
          View Order Details
        </div>
      </div>
    </div>
  );
};

export default ThankYou;